import { createFileRoute } from '@tanstack/react-router';

export enum LABEL_KEYS {
  VOICE = 'Voice',
  MESSAGE = 'Message',
}

type Search = {
  mode?: LABEL_KEYS;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/ai-receptionist')({
  validateSearch: (search: Search) => {
    return {
      mode: search.mode,
    };
  },
});
